import PaymentService from '@/services/PaymentService.js';

export default {
  state: {
    plans: [],
    pricing: [],
    billingInfo: null,
  },
  mutations: {
    SET_PLANS(state, payload) {
      state.plans = payload;
    },
    SET_PRICING(state, payload) {
      state.pricing = payload;
    },
    SET_BILLING_INFO(state, payload) {
      state.billingInfo = payload;
    },
  },
  actions: {
    async fetchPlans({ commit }) {
      try {
        const resp = await PaymentService.getPlans();
        commit('SET_PLANS', resp);
      } catch (e) {}
    },
    async fetchPricing({ commit }) {
      try {
        const resp = await PaymentService.getPricing();
        commit('SET_PRICING', resp);
      } catch (e) {}
    },
    async fetchBillingInfo({ commit }) {
      try {
        const resp = await PaymentService.getBillingInfo();
        commit('SET_BILLING_INFO', resp);
      } catch (e) {
        commit('SET_BILLING_INFO', null);
      }
    },
    updateBillingInfo({ commit }, data) {
      commit('SET_BILLING_INFO', data);
    },
  },
};
